import { useState, type FC, type ReactNode } from 'react';

import type { JobActionMenuOption } from '../useJobActionMenuOptions';

import { DropdownMenu } from './DropdownMenu';

import * as styles from './dropdown.css';

interface DropdownMenuProps {
  children: ({ open }: { open: boolean }) => ReactNode;
  disabled?: boolean;
  menuWidth: number;
  onDropdownMenuClick: (value: string) => void;
  options: JobActionMenuOption[];
  triggerRef?: React.RefObject<HTMLButtonElement> | null;
}

export const DROPDOWN_MENU_CONTAINER = 'dropdown-menu-container';

export const DropdownMenuContainer: FC<DropdownMenuProps> = ({
  children,
  disabled,
  menuWidth,
  onDropdownMenuClick,
  options,
  triggerRef,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = () => {
    if (disabled) {
      return;
    }

    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* This extra div here is for appending dropdown menus under via react portal */}
      {/* If not, the dropdown will be cut off partially or entirely by the table */}
      {/* So hirer won't be able to access the menus */}
      <div id={DROPDOWN_MENU_CONTAINER} />

      <div
        aria-labelledby="menu-label"
        aria-describedby="menu-label"
        className={styles.root}
        data-intercomid="jobActionsMenu"
      >
        <div onClick={() => toggleIsOpen()}>{children({ open: isOpen })}</div>

        <DropdownMenu
          isOpen={isOpen}
          onClick={onDropdownMenuClick}
          options={options}
          toggleIsOpen={toggleIsOpen}
          triggerRef={triggerRef}
          width={menuWidth}
        />
      </div>
    </>
  );
};
